import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { SelectionType } from '../../../shared/enums/selection-type';

import { MatSelectionList, MatListOption } from '@angular/material/list';
import { ProjectListItemComponent } from '../project-list-item/project-list-item.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LFProject } from '@lfw/roesberg.liveforms.core';

@Component({
  selector: 'lfw-project-list-view',
  templateUrl: './project-list-view.component.html',
  styleUrls: ['./project-list-view.component.css'],
  imports: [MatSelectionList, MatListOption, ProjectListItemComponent, TranslatePipe]
})
export class ProjectListViewComponent {
  @Input() data?: LFProject[] = undefined;
  @Output() itemSelected: EventEmitter<SelectionArguments> = new EventEmitter();

  isLoaded(): boolean {
    return this.data != undefined;
  }

  hasData(): boolean {
    return this.data != undefined && this.data.length > 0;
  }

  onSelection(event: any) {
    const selected = event.options[0].value;
    if (selected != undefined) {
      const args = new SelectionArguments();
      args.id = selected;
      args.action = SelectionType.Selected;
      this.itemSelected.emit(args);
    }
  }
}
